import Form from 'react-bootstrap/Form';
import React, { useState } from 'react';
import { _eval } from "../utils";
import BaseField from './BaseField';

function CheckboxesInput(props) {

    const [showError, setShowError] = useState(false);
    const [input, setInput] = useState([]);

    const handleChange = (v, s) => {
        props.data.value = false
        let validity = true

        // Check if we must map the field
        const map = (() => {
            if (_eval(props, 'data', 'map'))
                return props.data.map
            else
                return false
        })()

        var _input = input
        if (!s) {
            const index = _input.indexOf(v)
            if (index > -1)
                _input.splice(index, 1)
        }
        if (s) {
            _input.push(v)
            _input = [...new Set(_input)]
        }

        // Check if we must validate the field
        if (
            input === null
            || input === undefined
            || input.length === 0
        )
            validity = false

        // Check if the max checkboxes checked is respected
        if (
            (_eval(props, 'data', 'max'))
            && (props.data.max < _input.length)
        )
            validity = false

        setShowError(!validity)
        setInput(_input)

        const valuesSeparator = _eval(props, 'data', 'valuesSeparator') ? props.data.valuesSeparator : ', '
        _input = _input.join(valuesSeparator)

        // If we must keep the label in the value,
        // concat the label with the value
        if (_eval(props, 'data', 'keepLabel'))
            if (props.data.keepLabel === true)
                _input = props.data.label + ' -> ' + _input

        props.handleChange(props.data.sid, { value: _input, validity: validity, map: map })
    }

    return (
        <BaseField
            data={props.data}
            handleChange={props.handleChange}
            formData={props.formData}
        >

            {props.data.label.length > 0 ?
                <Form.Label>
                    {props.data.label}
                    {props.data.required ?
                        <span className='text-danger'>&nbsp;*</span>
                        : null}
                </Form.Label>
                : null}

            {props.data.items.map((c, i) => {
                const label = !_eval(c, 'label') ? c : c.label;
                const value = !_eval(c, 'value') ? c : c.value;
                if (c.groupLabel) {
                    return (
                        <div key={i} className='text-muted my-2'><i>— {c.groupLabel}</i></div>
                    )
                } else {
                    return (
                        <Form.Check
                            checked={input.includes(value) || props.data.value === value}
                            onChange={e => { handleChange(value, e.target.checked) }}
                            key={i}
                            type="checkbox"
                            id={`checkbox-for-${props.data.sid}-key-${i}`}
                            label={label}
                            data-validity-selector={props.data.sid}
                            disabled={value.disabled}
                        />
                    )
                }
            })}

            {/* Field helper */}
            {props.data.helper ?
                <Form.Text id={`helper-for-${props.data.sid}`} muted dangerouslySetInnerHTML={{ __html: props.data.helper }} />
                : null}

            {/* Field live check */}
            {props.data.error && showError ?
                <div>
                    <Form.Text id={`error-for-${props.data.sid}`} className='text-danger'>
                        {props.data.error}
                    </Form.Text>
                </div>
                : null}

            {/* Field check validity on submit */}
            {!(props.data.error && showError) ?
                <Form.Control.Feedback type="invalid">
                    {props.data.error}
                </Form.Control.Feedback>
                : null}

        </BaseField>
    );
}

export default CheckboxesInput;